import React, { useState, useEffect } from "react";
import {  useNavigate, useLocation} from "react-router-dom";
import Sidebar from "../../components/sidebar";
import { BASE_URL } from "../../utils/config";
import {  Modal, Alert } from "react-bootstrap";
import Container from 'react-bootstrap/Container';

const EditProfile = () => {
  const location = useLocation();
  const edittype = location.state && location.state.edittype;
  const EditscreenUserDetails = location.state && location.state.userdetials;
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [formData, setFormData] = useState({});
  const [showInvalidEmailAlert, setShowInvalidEmailAlert] = useState(false);
  const [showInvalidPhoneAlert, setShowInvalidPhoneAlert] = useState(false);
  const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] = useState(false);
  const [showInvalidNameAlert, setShowInvalidNameAlert] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [showEmptyAlert, setshowEmptyAlert] = useState(false);
  const [password, setPassword] = useState("");
  const [checkValidLoginPassword, setcheckValidLoginPassword] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%#&*])[A-Za-z\d@$!%*#&]{8,16}$/;
  const NameRegex = /^[a-zA-Z]+( [a-zA-Z]+)?$/;
  // const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/
  const phoneRegex = /^\d{10}$/;
  let count = 0
  useEffect(() => {
    if (count === 0) {
      fetchuserformdetails();
      count += 1;
    }
  }, []);


  //  this function is used to show edit form based on user role
  const fetchuserformdetails = () => {
    let usertype = localStorage.getItem("roleType");
    usertype = JSON.parse(usertype);
    setUserType(usertype);
    console.log("usertype", usertype);
    const userdetail = location.state && location.state.userdetials;
    console.log("userdetails", userdetail);
    setFormData(userdetail);

    if (usertype === "SuperAdmin") {
      setTimeout(() => {
        document.getElementById("status").value = userdetail.status;
        document.getElementById("role_type").value = userdetail.role_type;
        document.getElementById("automate_renko_access").value = userdetail.automate_renko_access;
        document.getElementById("renko_access").value = userdetail.renko_access;
      }, 500);

    }
  };





//  handle change of inout fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //  this function is used to submit the form 
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    try {
      if (
        formData.first_name === "" ||
        formData.first_name == null ||
        formData.last_name === "" ||
        formData.last_name == null ||
        formData.email_address === "" ||
        formData.email_address == null ||
        formData.phone_number === "" ||
        formData.phone_number == null ||
        formData.status === ""

      ) {
        setshowEmptyAlert(true);
      } else if (!emailRegex.test(formData.email_address)) {
        setShowInvalidEmailAlert(true);
        setTimeout(() => {
          setShowInvalidEmailAlert(false);
        }, 5000);
      } else if (!phoneRegex.test(formData.phone_number)) {
        setShowInvalidPhoneAlert(true);
        setTimeout(() => {
          setShowInvalidPhoneAlert(false);
        }, 5000);
      } else if (password !== "" && !passwordRegex.test(password)) {
        console.log("password", password);

        setShowInvalidPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidPasswordAlert(false);
        }, 5000);
      } else if (!NameRegex.test(formData.first_name)) {
        setShowInvalidNameAlert(true);
        setTimeout(() => {
          setShowInvalidNameAlert(false);
        }, 3000);
      } else if (
        formData.middle_name !== "" &&
        !NameRegex.test(formData.middle_name)
      ) {
        console.log("formData.middle_name", formData.middle_name);

        setShowInvalidNameAlert(true);
        setTimeout(() => {
          setShowInvalidNameAlert(false);
        }, 3000);
      } else if (!NameRegex.test(formData.last_name)) {
        setShowInvalidNameAlert(true);
        setTimeout(() => {
          setShowInvalidNameAlert(false);
        }, 3000);
      }
      else {
        let loginuser = JSON.parse(localStorage.getItem("loginData"));
        
        let body = JSON.stringify({
          userdetails: formData,
          modified_by: loginuser.user_id,
          updatedPassword: password,
        });
        console.log("body", body);
        fetch(`${BASE_URL}/updateuser/${formData.user_id}`, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
             'Authorization': `Bearer ${loginuser.token}`
          },
        })
          .then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            if (res.success === true) {
              let userdata = res.UserDataDetails;
              console.log("userdata", userdata);
              if (res.UserDataDetails.role_type ==="SuperAdmin"){
              localStorage.setItem("userdetails", JSON.stringify(userdata));
              }
              setShowSuccessMessage(true); // Show success message here
              setTimeout(() => {
                setShowSuccessMessage(false);
                if (loginuser.role_type === "SuperAdmin") {
                  navigate("/userlist");
                } else {
                  navigate("/home");
                }
              }, 3000);
            }else if(res.status === 403){ 
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); 
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage(``)
                localStorage.clear()
                navigate('/login')
              }, 3000); 
            }
            else if(res.status === 401){
            
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); 
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage(``)
                localStorage.clear()
                navigate('/login')
              }, 3000);

            } else {
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); 
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage(``)
              }, 3000);

          
            }
          }).catch(error =>{
            setErrorMessage(`Error: ${error.message}`)
            setShowErrorMessage(true); 
            setTimeout(() => {
              setShowErrorMessage(false);
              setErrorMessage(``)
             
            }, 3000);
          })
      }
    } catch (error) {
      console.log("error", error);
      setErrorMessage(`Error: ${error.message}`)
            setShowErrorMessage(true); 
            setTimeout(() => {
              setShowErrorMessage(false);
              setErrorMessage(``)
             
            }, 3000);
    }
  };


  const handlePasswordfeildchange = () => {

    console.log("EditscreenUserDetails:",EditscreenUserDetails)
    navigate("/forgotpassword", {
      state: { show: "changepassword",EditscreenUserDetails:EditscreenUserDetails},
    });
  }

  return (
    <div>
   
      <Sidebar />

      <div className="add-user" style={{ marginTop: "100px" }}>
        <Container>
          {edittype === "self" ? <h1>Edit Profile</h1> : <h1>Edit User</h1>}
          <form onSubmit={handleSubmit}>
            <div className="general-information">
              <h6>General Information</h6>
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="first_name" style={{ color: "#000", fontWeight: "bold" }}>
                      First Name<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      placeholder="Enter your first name"
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="middle_name" style={{ color: "#000", fontWeight: "bold" }}>Middle Name</label>
                    <input
                      type="text"
                      id="middle_name"
                      name="middle_name"
                      value={formData.middle_name}
                      placeholder="Enter your Middle name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="last_name" style={{ color: "#000", fontWeight: "bold" }}>
                      Last Name<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Enter your Last name"
                      required
                      value={formData.last_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="email" style={{ color: "#000", fontWeight: "bold" }}>
                      E-mail<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="email_address"
                      name="email_address"
                      value={formData.email_address}
                      placeholder="Enter your E-mail Address"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="phone_number" style={{ color: "#000", fontWeight: "bold" }}>
                      Phone Number<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="phone_number"
                      name="phone_number"
                      placeholder="Enter your Phone Number"
                      maxLength={10}
                      onChange={handleChange}
                      value={formData.phone_number}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>


            {userType === "SuperAdmin" ? (
              <>

                <div className="account-maintenance">
                  <h6>Account Maintenance</h6>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label for="role type" style={{ color: "#000", fontWeight: "bold" }}
                        >Role Type<span className="astrik-mark">*</span></label>
                        <select
                          id="role_type"
                          name="role_type"
                          value={formData.role_type}
                          onChange={handleChange}
                        >
                          <option value="">Select User Role</option>
                          <option value="SuperAdmin">Super Admin</option>
                          <option value="Supervisor">Supervisor</option>
                          <option value="User">User</option>
                          <option value="MCXUser">MCX User</option>
                        </select>
                      </div>

                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label for="status" style={{ color: "#000", fontWeight: "bold" }}>
                          Status<span className="astrik-mark">*</span>
                        </label>
                        <select
                          id="status"
                          name="status"
                          required
                          //   value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>

                        </select>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label for="renko_access" style={{ color: "#000", fontWeight: "bold" }}>
                          Renko Access<span className="astrik-mark">*</span>
                        </label>
                        <select
                          id="renko_access"
                          name="renko_access"
                          required
                          //   value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="">Select Renko Permission</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>

                        </select>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label for="automate_renko_access" style={{ color: "#000", fontWeight: "bold" }}>
                          Automate Renko Access<span className="astrik-mark">*</span>
                        </label>
                        <select
                          id="automate_renko_access"
                          name="automate_renko_access"
                          required
                          //   value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="">Select Automate Renko Permission</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>

                        </select>
                      </div>
                    </div>
                    

                  </div>
                </div>

              </>
            ) : null}

            <div className="account-maintenance" style={{ marginTop: "30px" }}>
              <h6 style={{ cursor: "pointer" }} onClick={handlePasswordfeildchange}>Change Password</h6>
             
            </div>

           
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button className="btn-submit" type="submit" style={{ marginTop: "50px" }}>
                Update
              </button>
            </div>
          </form>
        </Container>
      </div>


      {/* Password Alert */}
      <Modal
        show={checkValidLoginPassword}
        onHide={() => setcheckValidLoginPassword(false)}
        style={{ paddingTop: "0", paddingBottom: "0" }}
      >
        {" "}
        <Alert variant="danger">
          " Please enter a valid password with at least 8 characters, including
          letters , special charecter "@" and numbers."
        </Alert>
      </Modal>

      {/* Success Alert */}
      <Modal
        show={showSuccessMessage}
        onHide={() => setShowSuccessMessage(false)}
        style={{ padding: 0 }}
      >
        {" "}
        <Alert variant="success">
          " User profile form has been Updated successfully."
        </Alert>
      </Modal>

      {/* failed Alert */}
      <Modal
        show={showErrorMessage}
        onHide={() => setShowErrorMessage(false)}
        style={{ padding: 0 }}
      >
        {" "}
        <Alert variant="danger">{errorMessage}</Alert>
      </Modal>

      {/* Email Alert */}
      <Modal
        show={showInvalidEmailAlert}
        onHide={() => setShowInvalidEmailAlert(false)}
      >
        {" "}
        <Alert variant="danger" style={{ margin: 0 }}>
          " Please enter a valid email address. Make sure to include "@" and use
          a proper domain (e.g., example.com)."
        </Alert>
      </Modal>

      {/* Password Alert */}
      <Modal
        show={showInvalidPasswordAlert}
        onHide={() => setShowInvalidPasswordAlert(false)}
        style={{ paddingTop: "0", paddingBottom: "0" }}
      >
        {" "}
        <Alert variant="danger">
          " Please enter a valid password with at least 8 characters, including
          letters , special charecter "@" and numbers."
        </Alert>
      </Modal>


      {/* Name Alert */}
      <Modal
        show={showInvalidNameAlert}
        onHide={() => setShowInvalidNameAlert(false)}
        style={{ paddingTop: "0", paddingBottom: "0" }}
      >
        {" "}
        <Alert variant="danger">
          " In First name, middle name and last name accept only characters."
        </Alert>
      </Modal>

      {/* Phone no Alert */}
      <Modal
        show={showInvalidPhoneAlert}
        onHide={() => setShowInvalidPhoneAlert(false)}
      >
        {" "}
        <Alert variant="danger">
          " Please enter a valid phone number. Phone numbers should consist of
          10 digits and can include optional dashes or spaces (e.g.,
          123-456-7890 or 1234567890)."
        </Alert>
      </Modal>

      {/* Empty Alert */}
      <Modal show={showEmptyAlert} onHide={() => setshowEmptyAlert(false)}>
        {" "}
        <Alert variant="danger">
          " Please fill in all required fields. Fields cannot be empty."
        </Alert>
      </Modal>
    </div>
  );
};

export default EditProfile;
